export const environment = {
    production: false,
    configuration: 'release',
    apiUrl: 'https://release.tiendaonemall.com.co/api',
    smsUrl: 'https://api.messaging-service.com',
    businessName: 'ONE MALL'
};